export const toEnglishDigits = (str) =>
str.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));


export function parseLocalizedNumber(str) {
    if (!str) return NaN;
  
    // 1) تبدیل اعداد فارسی و عربی به انگلیسی
    const persianDigits = "۰۱۲۳۴۵۶۷۸۹";
    const arabicDigits = "٠١٢٣٤٥٦٧٨٩";
  
    let normalized = str.replace(/[۰-۹]/g, d => persianDigits.indexOf(d))
                        .replace(/[٠-٩]/g, d => arabicDigits.indexOf(d));
  
    // 2) حذف کاماهای فارسی و انگلیسی
    normalized = normalized.replace(/[.,،]/g, match => (match === '.' ? '.' : ''));
  
    // 3) تبدیل به عدد
    return Number(normalized);
};

export const getSubscriptionInfo = (user) => {

    if (!user?.expireDate) {

        return {
            plan: "free",
            remainingDays: 0,
        };

    }

    const today = new Date();

    const registerDate = new Date(user.registerDate);

    const expireDate = new Date(user.expireDate);

    const remainingDays = Math.max(
        0,
        Math.ceil(
            (expireDate.getTime() - today.getTime()) /
            (1000 * 60 * 60 * 24)
        )
    );

    // اشتراک منقضی شده
    if (expireDate <= today) {

        return {
            plan: "free",
            remainingDays: 0,
        };

    }

    // طول کل اشتراک
    const totalDays = Math.round(
        (expireDate.getTime() - registerDate.getTime()) /
        (1000 * 60 * 60 * 24)
    );

    // اگر حدود 30 روز بود => Trial
    if (totalDays <= 32) {

        return {
            plan: "trial",
            remainingDays,
        };

    }

    // در غیر اینصورت => اشتراک حرفه‌ای
    return {

        plan: "pro",

        remainingDays,

    };

};


export const getPlan = (user) => {

    if (!user?.expireDate) return "free";

    const today = new Date();

    const expireDate = new Date(user.expireDate);

    // اشتراک یا دوره آزمایشی تمام شده
    if (expireDate <= today) {

        return "free";

    }

    const registerDate = new Date(user.registerDate);

    const totalDays = Math.round(
        (expireDate - registerDate) /
        (1000 * 60 * 60 * 24)
    );

    // دوره آزمایشی
    if (totalDays <= 32) {

        return "trial";

    }

    // اشتراک حرفه‌ای
    return "pro";

};